module.exports = __webpack_public_path__ + "static/mr-concert-performance-33-4abf1ab595d4516a473a5e49f07bc088.jpg";